export const ACTION_ACTIVATE_NEXT_TEAM = 'ACTIVATE_NEXT_TEAM';
export const ACTION_ACTIVATE_TEAM = 'ACTIVATE_TEAM';
export const ACTION_ACTIVATE_BASKET_BY_DIRECTION = 'ACTIVATE_BASKET_BY_DIRECTION';
export const ACTION_ACTIVATE_FIRST_TEAM = 'ACTIVATE_FIRST_TEAM';
export const ACTION_RECEIVE_GAME_INFO = 'RECEIVE_GAME_INFO';
export const ACTION_SET_RESULT = 'SET_RESULT';

export const receiveGameInfo = gameInfo => ({
    type: ACTION_RECEIVE_GAME_INFO,
    gameInfo,
});

export const setResult = (basketId, teamId, result, ob) => ({
    type: ACTION_SET_RESULT,
    basketId,
    teamId,
    result,
    ob,
});

export const activateNextTeam = currentTeamId => ({
    type: ACTION_ACTIVATE_NEXT_TEAM,
    currentTeamId,
});

export const activateTeam = teamId => ({
    type: ACTION_ACTIVATE_TEAM,
    teamId,
});

export const activateBasket = (currentBasketId, direction) => ({
    type: ACTION_ACTIVATE_BASKET_BY_DIRECTION,
    currentBasketId,
    direction,
});

export const activateFirstTeam = () => ({
    type: ACTION_ACTIVATE_FIRST_TEAM,
});



// WEBPACK FOOTER //
// ./src/apps/result_entry/actions.js